/*
 * MatrixAndConceptsTable Messages
 *
 * This contains all the text for the MatrixAndConceptsTable component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.MatrixAndConceptsTable';

export default defineMessages({
  underEditQuotasAppendix: {
    id: `${scope}.underEditQuotasAppendix`,
    defaultMessage: '(C=Count | A=Assigned | T=Target | R=Remaining)',
  },
  underEditMinimumResponsesAppendix: {
    id: `${scope}.underEditMinimumResponsesAppendix`,
    defaultMessage: '(C=Count | T=Target | R=Remaining)',
  },
  matrix: {
    title: {
      id: `${scope}.title`,
      defaultMessage: 'Matrix Table',
    },
    row: {
      placeholder: {
        id: `${scope}.row.placeholder`,
        defaultMessage: 'Type a statement',
      },
      tooltip: {
        id: `${scope}.row.tooltip`,
        defaultMessage: 'Remove statement',
      },
      carriedForwardTooltip: {
        id: `${scope}.row.carriedForwardTooltip`,
        defaultMessage:
          'To remove this statement you need to disable carry forward',
      },
    },
    column: {
      placeholder: {
        id: `${scope}.column.placeholder`,
        defaultMessage: 'Type a scale point',
      },
      tooltip: {
        id: `${scope}.column.tooltip`,
        defaultMessage: 'Remove scale point',
      },
      carriedForwardTooltip: {
        id: `${scope}.column.carriedForwardTooltip`,
        defaultMessage:
          'To remove this scale point you need to disable carry forward',
      },
    },
  },
  concepts: {
    title: {
      id: `${scope}.title`,
      defaultMessage: 'Monadic Block',
    },
    row: {
      placeholder: {
        id: `${scope}.row.placeholder`,
        defaultMessage: 'Attribute {index}',
      },
      tooltip: {
        id: `${scope}.row.tooltip`,
        defaultMessage: 'Remove Attribute',
      },
    },
    column: {
      placeholder: {
        id: `${scope}.column.placeholder`,
        defaultMessage: 'Concept {index}',
      },
      tooltip: {
        id: `${scope}.column.tooltip`,
        defaultMessage: 'Remove Concept',
      },
    },
  },
});
